var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronDownSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Chevron_down_small") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Chevron_down_small",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-8-Copy",
    transform: "translate(20.364, 20.364) rotate(-45) translate(-20.364, -20.364)translate(15.864, 15.864)",
    stroke: "#000000",
    strokeWidth: 1.4
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0.878679656,
    y1: 0.878679656,
    x2: 5.12132034,
    y2: 5.12132034,
    id: "Line-2",
    transform: "translate(3, 3) rotate(45) translate(-3, -3)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 8.12132034,
    y1: 3.87867966,
    x2: 3.87867966,
    y2: 8.12132034,
    id: "Line-2",
    transform: "translate(6, 6) rotate(45) translate(-6, -6)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronDownSmall);
export default __webpack_public_path__ + "static/media/chevron_down_small.d764682b9203cc4bb30464f7c22e934a.svg";
export { ForwardRef as ReactComponent };